export default __webpack_public_path__ + "static/media/team2.850ef740.jpeg";